import about from './about';
import auth from './auth';
import general from './general';
import product from './product';

const id = {
  about,
  auth,
  general,
  product,
};

export default id;
